import { render } from "./DesktopTransactionsList.vue?vue&type=template&id=d287a7f2&scoped=true&ts=true"
import script from "./DesktopTransactionsList.vue?vue&type=script&lang=ts"
export * from "./DesktopTransactionsList.vue?vue&type=script&lang=ts"

import "./DesktopTransactionsList.vue?vue&type=style&index=0&id=d287a7f2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d287a7f2"]])

export default __exports__